export default {
    1: ['yield', 'gold', 'exp', 'rareDrop'],
    5: ['grow', 'overgrow', 'mutate', 'grass'],
    10: ['dna', 'gnome', 'lonely', 'fertile'],
    15: ['mystery', 'conversion', 'prestige', 'rareDropChance'],
    20: ['lucky', 'finalize', 'selfless', 'unyielding'],
    25: ['teamwork', 'hunter', 'patient'],
}
